export default "__VITE_ASSET__lxfCG35r__"